import type { FC } from 'react'
import { useDrag } from 'react-dnd'

export interface BoxProps {
	name: string;
	title: string;
	type: string;
}

interface DropResult {
	name: string
}

export const Box: FC<BoxProps> = function Box({ name, title, type }) {
	const [{ handlerId }, drag] = useDrag(() => ({
		type,
		item: { name },
		end: (item, monitor) => {
			const dropResult = monitor.getDropResult<DropResult>()
			if (item && dropResult) {
				//
			}
		},
		collect: (monitor) => ({
			handlerId: monitor.getHandlerId(),
		}),
	}))



	return (
		<div ref={drag} data-testid={'box'} data-handler-id={handlerId}  className="inject-box">
			<div className={name}>
				<div className={`${name}-svg menu-svg`}>
					<img src={`/img/${name}.svg`} className={`${name}-img`} alt="" />
				</div>
				<div className="item-text">{title}</div>
			</div>
		</div>
	)
}
